import { render, staticRenderFns } from "./Results-muchadd.vue?vue&type=template&id=083b83d4&scoped=true&"
import script from "./Results-muchadd.vue?vue&type=script&lang=js&"
export * from "./Results-muchadd.vue?vue&type=script&lang=js&"
import style0 from "./Results-muchadd.vue?vue&type=style&index=0&id=083b83d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083b83d4",
  null
  
)

export default component.exports